<template>
  <main class="main">
      <organization_header :dropshipping="true" v-if="$store.getters.getCompany.dropshipping"/>
      <div class="search-block"  v-if="type == 2 && $store.getters.getCompany.dropshipping">
          <div class="worker-header">
              <div class="hitem">
                  <div class="hinputs">
                      <input autocomplete="off" placeholder="Поиск поставщика" @keyup="searchProvider()" v-model="search">
                      <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
                  </div>
              </div>
          </div>
      </div>
      <button class="btn-join" v-if="show" @click="join()">Учавствовать в дропшиппинге</button>
      <loading-container :loading="loading" v-if="type == 1 && $store.getters.getCompany.dropshipping">
          <div class="bordered-card">
              <div class="bordered-card__head">Мои товарные категории доступные по системе дропшиппинг</div>
              <div class="bordered-card__items">
                  <div class="tree-container">
                      <tree :key="key" :data="categories" @node:checked="select" @node:unchecked="select"/>
                  </div>
              </div>
          </div>
      </loading-container>
      <loading-container :loading="loading" v-if="type == 2 && $store.getters.getCompany.dropshipping">
          <div class="dropshipping-table-block bordered-card">
              <div class="bordered-card__items" v-if="$route.name != 'drcompur'">
                  <table>
                      <tr>
                          <th>Поставщик</th>
                          <th>Договор</th>
                      </tr>
                      <tr v-for="provider in providers" :key="provider.id" class="tc">
                          <td>
                              <router-link class="links_color" :to="'/profile/' + provider.id">
                                  {{provider.name}}
                              </router-link>
                          </td>
                          <td>
                              {{provider.contract != null ? 'Есть' : ''}}
                              <button class="btn-status" @click="$refs.pcm.open(provider.user_id)" v-if="provider.contract == null">Заключить договор</button>
                          </td>
                      </tr>
                  </table>
              </div>
              <div class="bordered-card__items" v-if="$route.name == 'drcompur'">
                  <table>
                      <tr>
                          <th>Поставщик</th>
                      </tr>
                      <tr v-for="provider in providers" :key="provider.id" class="tc">
                          <td>
                              <router-link class="links_color" :to="'/provider-commission/' + provider.id">
                                  {{provider.name}}
                              </router-link>
                          </td>
                      </tr>
                  </table>
              </div>
          </div>
      </loading-container>
      <pur-cont-modal ref="pcm"></pur-cont-modal>
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import PurContModal from "@/components/modals/purchaser-contract-modal";
import organization_header from "@/components/OrganizationHeader.vue"

export default {
  name: "dropshipping",
  components: {
    LoadingContainer,
    PurContModal,
    organization_header
  },
  data: ()=>({
    show: true,
    type: '',
    categories: [],
    selected: [],
    selected_categories: [],
    key: 0,
    loading: true,
    providers: '',
    search: '',
    t: null
  }),
  mounted() {
    if (this.$store.getters.getCompany.dropshipping) {
      this.show = false;
    }

    this.type = localStorage.getItem('type');

    if (this.type == 1 && this.$store.getters.getCompany.dropshipping) {
        this.getSelectedCategories();
    }

    if (this.type == 2 && this.$store.getters.getCompany.dropshipping) {
        this.getProviders();
    }
  },
  methods: {
    join() {
      this.$http.post('/join-dropshipping', {
        token: localStorage.getItem('token')
      }).then(({data}) => {
        if (data.success) {
          this.show = false;
          this.$store.getters.getCompany.dropshipping = 1;
          this.$toast.success('Вы подключены к системе дропшиппинга.');
          if (this.type == 1) {
            this.getSelectedCategories();
          }
          if (this.type == 2) {
            this.getProviders();
          }
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    searchProvider() {
      if(this.t)clearTimeout(this.t)
      this.t = setTimeout(()=>{
        this.getProviders();
      },1000)
    },
    getSelectedCategories() {
      this.$http.post( '/get-dropshipping-categories-ids',{
        token: localStorage.getItem('token'),
      }).then(({data}) => {
        if (data.categories) {
          this.selected_categories = data.categories;
          this.getCategories();
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
    },
    getCategories() {
      this.$http.post( '/get-categories',{
        token: localStorage.getItem('token'),
      }).then(({data}) => {
        if (data.categories) {
          if(this.selected_categories.length > 0){
            data.categories = this.autoSelect(data.categories)
          }

          this.categories = data.categories;
          this.key++;
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
      .finally(()=> this.loading = false)
    },
    getProviders() {
      this.loading = true
      this.$http.post( '/get-dropshipping-providers',{
        token: localStorage.getItem('token'),
        search: this.search
      }).then(({data}) => {
        if (data.providers) {
          this.providers = data.providers;
        }
      })
      .catch(function(){
        this.$toast.error('Ошибка!');
      })
      .finally(()=> this.loading = false)
    },
    autoSelect(data){
      let selected = this.selected_categories
      let th = this

      return data.map((item)=>{
        if(item.children){
          item.children = th.autoSelect(item.children)
        }
        item.state = {}
        if(selected.some(sel => {
          return String(sel) == String(item.id)
          })){
            item.state.checked = true
          }else{
            item.state.checked = false
          }
          return item;
      })
    },
    select(val) {
      this.selected = [];
      if(this.t)clearTimeout(this.t)
      val.tree.checkedNodes.forEach((item)=>{
        this.selected.push(item.id)
      })
      this.t = setTimeout(()=>{
        //TODO: Ивент для селекта и обновления
        this.$http.post( '/add-dropshipping-categories',{
          token: localStorage.getItem('token'),
          categories: this.selected
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Категории успешно изменены');
          }
        }).catch(function(){
          this.$toast.error('Ошибка!');
        })
      },100)
    }
  }
}
</script>

<style lang="scss">
    .dropshipping-table-block.bordered-card{
        background: #FFFFFF;
        box-shadow: 0px 0px 3px #E5E5EA;
        border-radius: 4px;
        border: 1px solid #EEF0F3;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #2D3137;
        width: 50%;

    &__head{
         padding: 15px;
         border-bottom: 1px solid #EEF0F3;
     }
    &__items{
         background: #FFFFFF;
     }
    }
</style>

<style scoped lang="scss">
.btn-status {
    border: none;
    height: 40px;
    width: 200px;
    background: #2CB181;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    cursor: pointer;
}
.tree-container {
    background-color: white;
    width: 100%;
}
.btn-join {
    padding: 0 16px;
    background: #2CB181;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    height: 40px;
    border: none;
    outline: none;
    border-radius: 4px;
    width: 344px;
    position: absolute;
    right: 40px;
}

.worker {
    position: relative !important;

    &-header {
         display: flex;
         justify-content: space-between;
         align-items: center;
         margin-bottom: 16px;
         position: relative;

        .hitem{
            width: 100%;
            display: flex;
            align-items: center;
            width: 300px;
            position: absolute;
            right: 40px;
            top: -57px;
        }

        .hinputs {
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            margin: 0;
            div {
                width: 100%;
            }

            input {
                border: 1px solid #EEF0F3;
                box-sizing: border-box;
                border-radius: 4px;
                font-size: 12px;
                width: 100%;
                height: 40px;
                padding: 0 40px 0 15px;
                outline: none;
            }

            > img {
                  position: absolute;
                  right: 15px;
                  bottom: 50%;
                  transform: translateY(50%);
                  width: 14px;
                  height: 14px;
              }

        }
    }
}
</style>
